<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <div v-if="!loading">
            <component-header
                title="View Commission"
                :hasSearch="false"
                :hasReload="false"
                :hasCreate="false"
                :hasback="true"
                @back-press="$router.push('/setup/commission')"
            />
            <ValidationObserver v-slot="{ invalid }">
                <b-row>
                    <b-col>
                        <b-card>
                            <b-row>
                                <b-col cols="12" sm="12" md="4">
                                    <label class="label"
                                        >Commission Rule Name</label
                                    >
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Commission Rule Name"
                                    >
                                        <input
                                            type="text"
                                            disabled
                                            placeholder="Enter Rule Name"
                                            class="form-control"
                                            v-model="commissionRuleName"
                                            required
                                        />
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>

                                <b-col cols="12" sm="12" md="4">
                                    <label class="label"
                                        >Commission Rule Type</label
                                    >
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Commission Rule Type"
                                    >
                                        <ebSelect
                                            id="commissionRuleType"
                                            label="text"
                                            disabled
                                            v-model="commissionRuleType"
                                            :options="commissionRuleTypeOption"
                                            :selected="commissionRuleType"
                                            placeholder="Select Rule Type"
                                        >
                                        </ebSelect>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" sm="12" md="4">
                                    <label class="label">Event Type</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Commission Event Type"
                                    >
                                        <ebSelect
                                            id="eventtype"
                                            label="text"
                                            disabled
                                            v-model="eventtype"
                                            :selected="eventtype"
                                            :options="eventTypeOption"
                                            placeholder="Select event Type"
                                        >
                                        </ebSelect>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="4">
                                    <label class="label"> Applicable To </label>
                                    <br />
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Commission Applicable To"
                                    >
                                        <ebSelect
                                            id="applicableTo"
                                            label="text"
                                            disabled
                                            v-model="applicableTo"
                                            :options="applicableToOption"
                                            placeholder="Select Applicable To"
                                            :selected="applicableTo"
                                        ></ebSelect>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" sm="12" md="4">
                                    <label class="label"> Applied On </label>
                                    <br />
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Commission Applied On"
                                    >
                                        <ebSelect
                                            id="appliedOn"
                                            label="text"
                                            disabled
                                            v-model="appliedon"
                                            :options="appliedOnOption"
                                            :selected="appliedon"
                                            placeholder="Select Applied On"
                                        ></ebSelect>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                                <b-col>
                                    <label class="label"
                                        >Commission value Percentage</label
                                    >
                                    <ValidationProvider
                                        rules="required|between:0,100"
                                        v-slot="{ errors }"
                                        name="Commission value Percentage"
                                    >
                                        <input
                                            disabled
                                            type="text"
                                            class="form-control"
                                            :placeholder="`Enter Value`"
                                            v-model="commissionValue"
                                            required
                                        />
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="4">
                                    <label class="label">Charge Code</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Charge Code"
                                    >
                                        <input
                                            type="text"
                                            disabled
                                            placeholder="Enter Charge Code"
                                            class="form-control"
                                            v-model="chargeCode"
                                            required
                                        />
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "CommissionRuleView",
    components: {
        ebSelect,
        ValidationProvider,
        ValidationObserver,
        ComponentHeader,
        AtomSpinner,
    },

    data() {
        return {
            loading: false,
            commissionRuleName: "",
            commissionRuleType: "",
            commissionValue: "",
            eventtype: "",
            appliedon: "",
            chargeCode: "",
            commissionRuleTypeOption: [
                { value: "BASEMENT", text: "Basement" },
                { value: "GROUND", text: "Ground" },
                { value: "ORDER", text: "Order" },
                { value: "ITEM", text: "Item" },
            ],
            applicableTo: "",
            applicableToOption: [
                { value: "PARTNER", text: "Partner" },
                { value: "SELLER", text: "Seller" },
                { value: "DELIVERY_AGENT", text: "Delivery Agent" },
                { value: "DISTRIBUTOR", text: "Distributor" },
            ],
            appliedOnOption: [
                { value: "ORDER_AMOUNT", text: "Order Amount" },
                { value: "PAYMENT", text: "Payment" },
                { value: "INVOICE_AMOUNT", text: "Invoice Amount" },
                { value: "DELIVERY_COST", text: "Delivery Cost" },
            ],
            eventTypeOption: [
                { text: "Order-Fulfilled", value: "ORDER_FULFILLED" },
                { text: "Payment-Success", value: "PAYMENT_SUCCESS" },
                { value: "INVOICE_SUCCESS", text: "Invoice-Success" },
                // { value: "DISTRIBUTOR", text: "Distributor" }
            ],
        };
    },
    computed: {
        ...mapGetters({
            getEditCommissionRule: "commission/GetEditCommissionRule",
        }),
    },
    async mounted() {
        const id = this.$route.params?.id;
        if (!id) {
            this.$router.push("/setup/commission");
            return;
        }

        this.loading = true;
        await this.$store.dispatch("commission/editCommissionRuleAction", id);
        try {
            {
                let ruleObj = this.getEditCommissionRule;
                this.commissionRuleName = ruleObj.ruleName
                    ? ruleObj.ruleName
                    : "";
                this.commissionValue =
                    ruleObj.commission.rate * 100
                        ? ruleObj.commission.rate * 100
                        : "";
                this.commissionRuleType = {
                    value: ruleObj.ruleType ? ruleObj.ruleType : "",
                    text: ruleObj.ruleType
                        ? ruleObj.ruleType.charAt(0).toUpperCase() +
                          ruleObj.ruleType.slice(1).toLowerCase()
                        : "",
                };
                ((this.chargeCode = ruleObj.chargeCode),
                    (this.eventtype = {
                        value: ruleObj.eventType ? ruleObj.eventType : "",
                        text: ruleObj.eventType
                            ? ruleObj.eventType.charAt(0).toUpperCase() +
                              ruleObj.eventType.slice(1).toLowerCase()
                            : "",
                    }));
                this.applicableTo = {
                    value: ruleObj.commission.applicableTo
                        ? ruleObj.commission.applicableTo
                        : "",
                    text: ruleObj.commission.applicableTo
                        ? ruleObj.commission.applicableTo
                              .charAt(0)
                              .toUpperCase() +
                          ruleObj.commission.applicableTo.slice(1).toLowerCase()
                        : "",
                };
                this.appliedon = {
                    value: ruleObj.commission.appliedOn
                        ? ruleObj.commission.appliedOn
                        : "",
                    text: ruleObj.commission.appliedOn
                        ? ruleObj.commission.appliedOn.charAt(0).toUpperCase() +
                          ruleObj.commission.appliedOn.slice(1).toLowerCase()
                        : "",
                };
            }
        } catch (err) {}

        this.loading = false;
    },
};
</script>
<style>
.label {
    font-family: "Lato";
    font-weight: bold;
}
</style>
